import HighlightJS from '../node_modules/highlight.js/lib/common.js';
import MarkdownIt from 'markdown-it';

/**
 * See "Syntax highlighting" at https://github.com/markdown-it/markdown-it#usage-examples.
 *
 * Takes a string of language text and an optional language hint and returns an HTML string
 * for a <pre><code>...</code></pre> construction with classes from highlight.js if an
 * appropriate language can be found. If language hint is "plain", highlighting is not attempted
 * and a code block string with only escaped HTML is returned.
 *
 * @param {string} code  Code block body
 * @param {string} language Language hint (text following opening ``` in Markdown)
 * @returns {string} HTML string for code block with highlight.js classes potentially in place.
 */
const highlight = (code, language) => {
  const md = new MarkdownIt();
  if ('plain' !== language) {
    if (language && HighlightJS.getLanguage(language)) {
      try {
        return "<pre class=\"hljs\"><code>".concat(HighlightJS.highlight(code, {
          language,
          ignoreIllegals: true
        }).value, "</code></pre>");
      } catch (__) {
        // ignore exception
      }
    } else {
      try {
        return "<pre class=\"hljs\"><code>".concat(HighlightJS.highlightAuto(code).value, "</code></pre>");
      } catch (__) {
        // ignore exception
      }
    }
  }
  return "<pre class=\"hljs\"><code>".concat(md.utils.escapeHtml(code), "</code></pre>");
};
var highlight$1 = highlight;

export { highlight$1 as default };
